/* ============================================================
   SINGSPACE ADMIN - SECTION SÉCURITÉ COMPTE
   ============================================================ */

import { Lock } from 'lucide-react';
import { Button } from '../ui/button';
import { FieldGroup } from './FieldGroup';
import { SectionTitle } from './SectionTitle';

export function SecuritySection() {
  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <SectionTitle
        label="Sécurité & Authentification"
        description="Gérez la protection de votre compte et vos méthodes de connexion."
      />

      <div className="bg-white rounded-2xl border border-slate-100 p-6 shadow-sm">
        <FieldGroup 
          label="Mot de passe" 
          hint="Recommandé tous les 6 mois pour une sécurité optimale."
        >
          <Button
            variant="outline"
            className="h-11 px-6 rounded-xl border border-slate-200 font-semibold text-sm text-slate-900 hover:bg-slate-50 hover:border-slate-300 transition-all flex items-center gap-2"
          >
            <Lock size={16} />
            Changer mon mot de passe
          </Button>
        </FieldGroup>
      </div>
    </div>
  );
}
